import { render, staticRenderFns } from "./PlayerIconShape.vue?vue&type=template&id=6ad2d108&"
import script from "./PlayerIconShape.vue?vue&type=script&lang=js&"
export * from "./PlayerIconShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports